export const CARD_IMAGES = {
  petronas_smartpay: "https://customer-assets-jt897jd0.emergentagent.net/job_drive-smart-25/artifacts/m5zknv31_smartpay-postpaid-chip.png",
  shell_card: "https://customer-assets-jt897jd0.emergentagent.net/job_drive-smart-25/artifacts/3o5qzmvj_Shell_card_95d7d1c698.png",
};
